import {
  IMarketStatCollectionFilters,
  IMarketStatsBasePayload,
  IMarketStatsData,
} from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stats/IMarketStat';
import { SortOrder } from '@creditflowresearch/uilib/Table/DataTable/interfaces/SortOrder';

export const STATS_TILE_PER_PAGE = 10;

export const initialStatsTileCollectionFiltersState: IMarketStatCollectionFilters = {
  search: '',
  sortBy: 'updatedAt',
  sortOrder: 'desc' as SortOrder,
  page: 1,
  perPage: STATS_TILE_PER_PAGE,
};

export const initialStatsTileBasePayload: IMarketStatsBasePayload = {
  filter: {},
  isExtended: false,
};

export const initialStatsTileData: IMarketStatsData = {
  collection: [],
  totalCount: 0,
  payload: initialStatsTileBasePayload,
};
